module.exports = __webpack_public_path__ + "img/reverse.8d58b56e.png";